// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("./Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function isArrowKey(key) {
  if (key === "ArrowLeft" || key === "ArrowRight" || key === "ArrowUp") {
    return true;
  } else {
    return key === "ArrowDown";
  }
}

var filteredKeyCodes = {
  hd: "Key[A-Z]",
  tl: {
    hd: "Digit[0-9]",
    tl: {
      hd: "Numpad[0-9]",
      tl: {
        hd: "Backquote",
        tl: {
          hd: "Minus",
          tl: {
            hd: "Equal",
            tl: {
              hd: "Backspace",
              tl: {
                hd: "Delete",
                tl: {
                  hd: "Bracket",
                  tl: {
                    hd: "Backslash",
                    tl: {
                      hd: "Semicolon",
                      tl: {
                        hd: "Quote",
                        tl: {
                          hd: "Comma",
                          tl: {
                            hd: "Period",
                            tl: {
                              hd: "Slash",
                              tl: {
                                hd: "Space",
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

var reVisual = new RegExp($$String.concat("|", filteredKeyCodes));

function isVisualCode(code) {
  return reVisual.test(code);
}

function isMetaCode(code) {
  switch (code) {
    case "MetaLeft" :
    case "MetaRight" :
        return true;
    default:
      return false;
  }
}

function isModifierCode(code) {
  switch (code) {
    case "AltLeft" :
    case "AltRight" :
    case "ControlLeft" :
    case "ControlRight" :
    case "MetaLeft" :
    case "MetaRight" :
    case "ShiftLeft" :
    case "ShiftRight" :
        return true;
    default:
      return false;
  }
}

var reCode = /^Key(.)$/;

var reDigitCode = /^Digit(\d)$/;

var reNumpadCode = /^Numpad(\d)$/;

function processRegExExecResult(result) {
  Curry._2(Log$SmartcutsMacros.keyLogic.log2, "Captures", result);
  var nullableString = ArrayUtils$SmartcutsMacros.get(1, result);
  if (nullableString === undefined) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected match");
  }
  var arg = Caml_option.nullable_to_opt(Caml_option.valFromOption(nullableString));
  return (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("Expected at least 1 regex capture").toLowerCase();
}

function getCharFromCode(key, code) {
  var result = reCode.exec(code);
  if (result !== null) {
    return processRegExExecResult(result);
  }
  var result$1 = reDigitCode.exec(code);
  if (result$1 !== null) {
    return processRegExExecResult(result$1);
  }
  var result$2 = reNumpadCode.exec(code);
  if (result$2 !== null) {
    return processRegExExecResult(result$2);
  } else {
    Curry._3(Log$SmartcutsMacros.keyLogic.log3, "NO CAPTURES or exact match", code, reCode);
    return key;
  }
}

var keyCodesAssocWithCursorMove = {
  hd: 37,
  tl: {
    hd: 38,
    tl: {
      hd: 39,
      tl: {
        hd: 40,
        tl: /* [] */0
      }
    }
  }
};

exports.keyCodesAssocWithCursorMove = keyCodesAssocWithCursorMove;
exports.isArrowKey = isArrowKey;
exports.filteredKeyCodes = filteredKeyCodes;
exports.reVisual = reVisual;
exports.isVisualCode = isVisualCode;
exports.isMetaCode = isMetaCode;
exports.isModifierCode = isModifierCode;
exports.reCode = reCode;
exports.reDigitCode = reDigitCode;
exports.reNumpadCode = reNumpadCode;
exports.getCharFromCode = getCharFromCode;
/* reVisual Not a pure module */
